import { useSelector } from 'react-redux'
import * as R from 'ramda'

import { useExportResourceModal } from 'components/modals/common/ExportResourceModal/hooks'
import { useModal } from 'hooks'
import { getFileName } from 'utils/sheet'
import { percentScore } from 'utils/stringFormat'

export const useExportCandidateGroupState = () => {
  const { candidates } = useSelector(state => state.orm)

  const fileName = getFileName('candidates')

  const pks = R.keys(candidates?.meta?.selected) || []

  const data = R.pipe(
    R.pick(pks),
    R.values,
    R.map(
      R.applySpec({
        name: R.prop('name'),
        email: R.prop('email'),
        phone: R.prop('phone'),
        gma_score: R.pipe(R.path(['scores', 'GMA']), v => percentScore(v, '')),
        personality_score: R.pipe(R.path(['scores', 'Personality']), v =>
          percentScore(v, ''),
        ),
        test_score: R.pipe(R.path(['scores', 'Ebber Test Score']), v =>
          percentScore(v, ''),
        ),
        interview_score: R.pipe(R.path(['scores', 'Interview']), v =>
          percentScore(v, ''),
        ),
        final_score: R.pipe(R.path(['scores', 'Ebber Final Score']), v =>
          percentScore(v, ''),
        ),
      }),
    ),
  )(candidates?.items)

  const { handleExportFile } = useExportResourceModal({ data })

  const handleExportCSV = handleExportFile(`${fileName}.csv`)

  const handleExportXLXS = handleExportFile(`${fileName}.xlsx`)

  return {
    state: { data },
    handlers: { handleExportCSV, handleExportXLXS },
  }
}

export const useExportCandidateGroupModal = () => {
  const { handleClose, handleOpen, isOpen } = useModal()

  return {
    handleExportCandidateGroupModalClose: handleClose,
    handleExportCandidateGroupModalOpen: handleOpen,
    isExportCandidateGroupModalOpen: isOpen,
  }
}
